import React, { ReactNode, Suspense } from 'react';
import {
  useSidePanel,
  setSidePanelOpening,
  showSidePanel,
} from '../../../../features/SidePanel';
import { Trigger } from './Trigger';
import { IconMore } from './IconMore';
import { Name } from './Name';

export function FlyOutToggle({
  avatar,
  name,
}: {
  avatar: ReactNode;
  name: ReactNode;
}) {
  const [{ shouldShowSidePanel }, sidePanelDispatch] = useSidePanel();

  const openSidepanel = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    sidePanelDispatch(showSidePanel());
    sidePanelDispatch(setSidePanelOpening(true));
  };

  return (
    <Trigger
      aria-controls="side-panel-container"
      aria-expanded={shouldShowSidePanel}
      onClick={openSidepanel}
      data-testid="navigation-flyout-toggle"
      data-slo-id="active-artist"
    >
      <IconMore />
      <Suspense fallback={null}>
        {avatar} <Name>{name}</Name>
      </Suspense>
    </Trigger>
  );
}
